import { END, eventChannel, type SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

type Unsubscribe = () => void;
type Emitter<T> = (input: T | END) => void;
type Subscribe<T> = (cb: Emitter<T>) => Unsubscribe;

export const getStorageListener =
  (key: string, emitter: Emitter<StorageEvent>) =>
  (event: StorageEvent): void => {
    if (event.key === key) {
      emitter(event);
      localStorage.removeItem(key);
      emitter(END);
    }
  };

export const getEventCallback =
  (key: string): Subscribe<StorageEvent> =>
  (emitter: Emitter<StorageEvent>): Unsubscribe => {
    const listener = getStorageListener(key, emitter);
    window.addEventListener('storage', listener);
    return (): void => {
      window.removeEventListener('storage', listener);
    };
  };

export function* getStorageChannel(key: string): SagaIterator {
  const callback = yield call(getEventCallback, key);
  return yield call(eventChannel, callback);
}
